const themes = [
    {
        name: "light",
        color: "#fff",
        
    },
    {
        name: "yellow",
        color: "#f6f3e0",
    },
    {
        name: "green",
        color: "#cdf0d0",
    },
    {
        name: "dark",
        color: "#232733",
    }
]


const fontsizes = [
    {
        name: "",
        size: 16
    },
    {
        name: "",
        size: 18
    },
    {
        name: "",
        size: 20
    },
    {
        name: "",
        size: 22
    },
    {
        name: "",
        size: 24
    },
    {
        name: "",
        size: 28
    }
]

const defaultConfig = {
    defaultTheme: 1,
    defaultFontsize: 2
}


export default {
    themes,
    fontsizes,
    defaultConfig
}


// WEBPACK FOOTER //
// ./src/utils/config.js